import { render, staticRenderFns } from "./AtendimentosPage.vue?vue&type=template&id=5a6b7091&scoped=true"
import script from "./AtendimentosPage.vue?vue&type=script&lang=js"
export * from "./AtendimentosPage.vue?vue&type=script&lang=js"
import style0 from "./AtendimentosPage.vue?vue&type=style&index=0&id=5a6b7091&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b7091",
  null
  
)

export default component.exports